export const classesDashboardSx = {
  refundModalBox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'white',
    borderRadius: "30px",
    boxShadow: 24,
    p: 4,
  },
  modalDescription: {
    mt: 2
  },
  modalButtonsWrapper: {
    mt: 3,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 2
  },
  buttonNo: {
    color: "white",
    backgroundColor: 'green',
    '&:hover': { backgroundColor: 'darkgreen' }
  },
  buttonYes: {
    color: "white",
    backgroundColor: 'red',
    '&:hover': { backgroundColor: 'darkred' }
  },
  loaderBox: {
    my: 2
  },
  classHeaderBox: {
    display: { xs: 'none', md: 'block' }
  },
  classContainer: {
    width: "100%",
    overflowY: 'scroll',
    '::-webkit-scrollbar': { display: 'none !important' },
    mb: 2
  },
  classTabBox: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    my: 4
  },
  tabItem: {
    position: 'relative'
  },
  tabTypography: (isActive) => ({
    cursor: "pointer",
    borderBottom: isActive ? "4px solid" : "4px solid #ccc",
    pl: 1,
    pr: 1,
    pb: 2
  }),
  tabCountBadge: {
    backgroundColor: "#000080",
    borderRadius: '50%',
    width: 25,
    height: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ml: 1,
    position: 'relative',
    top: -20,
    left: -10
  },
  tabCountText: {
    color: "white"
  },
  classListWrapper: {
    display: 'flex',
    gap: 4,
    flexWrap: 'wrap'
  },
  pageWrapper: {
    width: "100%",
    pb: { xs: 10, md: 0 }
  }
};
